import React, { PureComponent } from 'react';
import {
SelectField,
  Button,
  DialogContainer,
  Divider,
  TextField,
  Toolbar,
} from 'react-md';

export default class AddProjectDialog extends PureComponent {
  state = { visible: false, pageX: null, pageY: null };
  show = (e) => {
    // provide a pageX/pageY to the dialog when making visible to make the
    // dialog "appear" from that x/y coordinate
    let { pageX, pageY } = e;
    if (e.changedTouches) {
      pageX = e.changedTouches[0].pageX;
      pageY = e.changedTouches[0].pageY;
    }

    this.setState({ visible: true, pageX, pageY });
  };

  hide = () => {
    this.props.hideAddRowDialog();
  };

    add = () => {
      this.props.addProject("Aloooo");
    };


      handleSubmit = (e) => {

        const newDessert = this.parseNewDesserts(e);
        this.props.addProject(newDessert);

      };

    parseNewDesserts = e => [].reduce.call(e.target.elements, (desserts, el) => {
        const {id, name, type, value, checked } = el;
        if (!id) { // buttons
          return desserts;
        }

        //alert(id + ": " + this.state.email);


       // dessert = {"name" : value};
       const dessert = desserts[0] || { id: 1, isNew: true };

        dessert[id] = value;

        desserts[0] = dessert;
        return desserts;
      }, {});

  render() {
    const { pageX, pageY } = this.state;
    const { visible } = this.props;
    const STRING_ITEMS = ['SELENIUM'];
    return (
      <div>
<form className="md-grid text-fields__application" onSubmit={this.handleSubmit}>

        <DialogContainer
          id="simple-full-page-dialog"
          visible={visible}
          pageX={pageX}
          pageY={pageY}
          fullPage
          onHide={this.hide}
          aria-labelledby="simple-full-page-dialog-title"
        >
          <Toolbar
            fixed
            colored
            title="New Project"
            titleId="simple-full-page-dialog-title"
            nav={<Button icon onClick={this.hide}>close</Button>}
            actions={<Button type="submit" flat>Save</Button>}
          />
          <section className="md-toolbar-relative">

            <TextField id="name" placeholder="Name" block paddedBlock />
            <Divider />
            <TextField id="testFramework" placeholder="SELENIUM" value="SELENIUM" disabled block paddedBlock />
            <Divider />
            <TextField id="testfileType" placeholder="CUCUMBER" value="CUCUMBER" disabled block paddedBlock />
             <Divider />
            <TextField id="testRunner" placeholder="MAVEN" value="MAVEN" disabled block paddedBlock />
             <Divider />
            <TextField id="repositoryUrl" placeholder="https://github.com/fatihtokus/test-suit-test-project.git" defaultValue="https://github.com/fatihtokus/test-suit-test-project.git" block paddedBlock />
          </section>
        </DialogContainer>
        </form>
      </div>
    );
  }
}


// WEBPACK FOOTER //
// ./src/containers/Project/AddProjectDialog.js